module.exports = __webpack_public_path__ + "static/media/ciisnero-kulikitaka-art.368fa1e2.png";